import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ForgeCheckbox } from '@tylertech/forge-react';

import { I18n } from 'common/i18n';
import * as filters from 'common/components/AssetBrowser/actions/filters';

interface RecentlyViewedFilterProps {
  onlyRecentlyViewed: boolean;
  toggleRecentlyViewed: (value: boolean) => void;
}

export class RecentlyViewedFilter extends Component<RecentlyViewedFilterProps> {
  render() {
    const { onlyRecentlyViewed, toggleRecentlyViewed } = this.props;

    return (
      <div className="filter-section recently-viewed">
        <div className="checkbox checkbox-filter">
          <ForgeCheckbox
            id="filter-recently-viewed"
            onChange={toggleRecentlyViewed}
            checked={onlyRecentlyViewed}
          >
            {I18n.t('shared.asset_browser.filters.recently_viewed.label')}
          </ForgeCheckbox>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  onlyRecentlyViewed: state.filters.onlyRecentlyViewed,
});

const mapDispatchToProps = (dispatch: any) => ({
  toggleRecentlyViewed: () => dispatch(filters.toggleRecentlyViewed()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecentlyViewedFilter);
